"use client";

import { useRadioGroup } from "./RadioGroup";

export default function RadioItem({
    value,
    disabled = false,
}) {
    const group = useRadioGroup();

    const checked = group.value === value;

    return (
        <div className={`shrink-0 flex items-center justify-center w-5 h-5 rounded-full border-2 transition-all duration-200 
        ${disabled && "opacity-50 border-jmt-neutral-300"}
         ${checked ? "border-jmt-primary-800" : "border-jmt-neutral-300"}
      `}>

            <div className={` rounded-full transition-all duration-200 ${checked ? "w-3 h-3 bg-jmt-primary-800" : "w-0 h-0"}
        `} />

        </div>
    );
}